/**
 * BgGradientConic — Rotating conic gradient, premium/cinematic
 * Registro: produto reveal, CTA, momentos de impacto emocional
 * Paleta: configurável, default amber+teal premium
 */
import React from "react";
import {AbsoluteFill, useCurrentFrame, useVideoConfig} from "remotion";

interface BgGradientConicProps {
  /** Cor 1 do gradiente conic (default: amber) */
  color1?: string;
  /** Cor 2 do gradiente conic (default: teal) */
  color2?: string;
  /** Velocidade de rotação rev/s (default: 0.04) */
  rotSpeed?: number;
  /** Opacidade do gradiente 0–1 (default: 0.15) */
  opacity?: number;
}

export const BgGradientConic: React.FC<BgGradientConicProps> = ({
  color1 = "#F59E0B",
  color2 = "#14B8A6",
  rotSpeed = 0.04,
  opacity = 0.15,
}) => {
  const f = useCurrentFrame();
  const {fps} = useVideoConfig();
  const deg = (f / fps) * rotSpeed * 360;

  // Subtle scale breathe
  const breathe = 1 + Math.sin(f * 0.025) * 0.04;

  return (
    <AbsoluteFill style={{background: "#080808", overflow: "hidden"}}>
      {/* Primary conic sweep */}
      <div style={{
        position: "absolute",
        inset: "-20%",
        background: `conic-gradient(from ${deg}deg at 50% 50%,
          ${color1}00 0deg,
          ${color1} 60deg,
          ${color2} 180deg,
          ${color2}00 240deg,
          ${color1}00 360deg)`,
        opacity,
        transform: `scale(${breathe})`,
        filter: "blur(40px)",
        willChange: "transform",
      }}/>
      {/* Secondary counter-rotating accent */}
      <div style={{
        position: "absolute",
        inset: "-10%",
        background: `conic-gradient(from ${-deg * 0.6}deg at 30% 70%,
          ${color2}00 0deg,
          ${color2} 90deg,
          ${color2}00 180deg)`,
        opacity: opacity * 0.5,
        filter: "blur(60px)",
        willChange: "opacity",
      }}/>
      {/* Center bloom */}
      <div style={{
        position: "absolute",
        left: "50%", top: "45%",
        width: "45%", height: "45%",
        transform: `translate(-50%, -50%) scale(${breathe})`,
        background: `radial-gradient(circle, ${color1}15 0%, transparent 70%)`,
        filter: "blur(50px)",
        willChange: "transform",
      }}/>
      {/* Vignette strong */}
      <div style={{
        position: "absolute", inset: 0,
        background: "radial-gradient(ellipse at 50% 50%, transparent 30%, rgba(0,0,0,0.82) 100%)",
        pointerEvents: "none",
      }}/>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
